export const payModes = {
    CARD: 'stripe',
    IDEAL: 'ideal',
    BANK_TRANSFER: 'bank-transfer',
    MERCADO_PAGO: 'mercado-pago',
    P24: 'p24'
}

const commonRules = {
    '.Input': {
        fontWeight: '500'
    },
    '.Input:autofill': {},
}

const stripeAppearanceVariables = {
    www: {
        variables: {
            borderRadius: '30px',
            colorBackground: '#252336',
            colorPrimary: '#1867FF',
            colorPrimaryText: '#1A1B25',
            colorText: 'white',
            colorTextSecondary: 'white',
            colorTextPlaceholder: '#8f8f9d',
            focusBoxShadow: 'none',
            fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif',
        },
        rules: {
            ...commonRules
        }
    },
    ocisport: {
        variables: {
            borderRadius: '10px',
            colorBackground: '#ffffff',
            colorPrimary: '#ED7203',
            colorPrimaryText: '#1A1B25',
            colorText: '#100F23',
            colorTextSecondary: '#6e6d6d',
            colorTextPlaceholder: '#8f8f9d',
            focusBoxShadow: 'none',
        },
        rules: {
            ...commonRules
        }
    },
    webshow: {
        variables: {
            borderRadius: '10px',
            colorBackground: '#f4f4f4',
            colorPrimary: '#F49739',
            colorPrimaryText: '#1A1B25',
            colorText: '#100F23',
            colorTextSecondary: '#6e6d6d',
            colorTextPlaceholder: '#8f8f9d',
            focusBoxShadow: 'none',
        },
        rules: {
            ...commonRules
        }
    },
    carnival: {
        variables: {
            borderRadius: '10px',
            colorBackground: '#ffffff',
            colorPrimary: '#009EB3',
            colorPrimaryText: '#1A1B25',
            colorText: '#100F23',
            colorTextSecondary: '#6e6d6d',
            colorTextPlaceholder: '#8f8f9d',
            focusBoxShadow: 'none',
        },
        rules: {
            ...commonRules
        }
    },
    transgrancanaria: {
        variables: {
            borderRadius: '10px',
            colorBackground: '#ffffff',
            colorPrimary: '#0C9CD3',
            colorPrimaryText: '#1A1B25',
            colorText: '#100F23',
            colorTextSecondary: '#6e6d6d',
            colorTextPlaceholder: '#8f8f9d',
            focusBoxShadow: 'none',
        },
        rules: {
            ...commonRules
        }
    },
    bluserena: {
        variables: {
            borderRadius: '4px',
            colorBackground: '#FAFAFA',
            colorPrimary: '#0066FF',
            colorPrimaryText: '#1A1B25',
            colorText: '#100F23',
            colorTextSecondary: '#6e6d6d',
            colorTextPlaceholder: '#8f8f9d',
            focusBoxShadow: 'none',
        },
        rules: {
            ...commonRules
        },

    },
    costa: {
        variables: {
            borderRadius: '4px',
            colorBackground: '#F3F4F5',
            colorPrimary: '#111',
            colorPrimaryText: '#111',
            colorText: '#111',
            colorTextSecondary: '#6e6d6d',
            colorTextPlaceholder: '#8f8f9d',
            focusBoxShadow: 'none',
        },
        rules: {
            ...commonRules
        },

    },
    gardaland: {
        variables: {
            borderRadius: '14px',
            colorBackground: '#02367B',
            colorPrimary: '#fff',
            colorPrimaryText: '#fff',
            colorText: '#fff',
            colorTextSecondary: '#d3d1d1',
            colorTextPlaceholder: '#adadb6',
            focusBoxShadow: 'none',
        },
        rules: {
            ...commonRules,
            '.Tab': {
                backgroundColor: '#02367B',
                border: '1px solid #ffffff20',
            },
            '.TabIcon--selected': {
                fill: '#02367B',
            },
            '.TabLabel--selected': {
                color: '#02367B',
            },
            '.TabIcon--selected:hover': {
                fill: '#FFF',
            },
            '.Tab:hover': {
                backgroundColor: '#0a458f',
            },
            '.Tab--selected': {
                backgroundColor: '#ffffff',
                color: '#02367B',
            },
            '.Tab--selected:hover': {
                backgroundColor: '#fff',
            },
        },

    },
}

export function getAppearanceVariables(domain) {
    return stripeAppearanceVariables[domain] || stripeAppearanceVariables.www
}
